import React from 'react';
// import logoSrc from '../assets/Logo_Olfak_fond_Violet.png';
import logoSrc from '../../../assets/Logo_Olfak_fond_Violet.png';

const OlfaktionLogo: React.FC = () => (
  <div style={{ textAlign: 'center', marginBottom: 20 }}>
    <img src={logoSrc} alt="olfaktion" style={{ width: 160, display: 'block', margin: '0 auto' }} />
  </div>
);

export default OlfaktionLogo;
